var QRCode = require('qrcode')

const generateQRCode = async (
  url,
  options,
  callback
) => {
  try {
    return await QRCode.toDataURL(url, options, callback)
  } catch (err) {
    console.error(err)
  }
}

module.exports = generateQRCode
